import React from 'react';
import { DividerContainer } from './styles/DividerStyles';

export const Divider = ({ margin = '0 2rem' }) => (
  <DividerContainer role={'divider'} margin={margin}>
    |
  </DividerContainer>
);
